import { render, staticRenderFns } from "./PopoverImageOptions.vue?vue&type=template&id=5d3b8cec&scoped=true"
import script from "./PopoverImageOptions.vue?vue&type=script&lang=js"
export * from "./PopoverImageOptions.vue?vue&type=script&lang=js"
import style0 from "./PopoverImageOptions.vue?vue&type=style&index=0&id=5d3b8cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b8cec",
  null
  
)

export default component.exports